import React from 'react'
import styled from 'styled-components'
import {DropboxCreationContentItem} from '../CreationContentItem'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export default function DropboxCreationContent() {
  return (
    <StyledContainer>
      <DropboxCreationContentItem />
    </StyledContainer>
  )
}
